import { SetEnabledFeatures } from './actions';

export enum Features {
    SEARCH_UI_V2 = 'Enable new search UI 2',
    SEARCH_API_V2 = 'Enable new search API 2',
    VERIFICATION_UI = 'Enable new Verification UI',
    FULLSTORY = 'Enable FullStory for signup',
}

export type FeaturesList = {
    [K in Features]?: boolean;
};

export type FeatureFlags = {
    isLoading: boolean;
    features: FeaturesList;
};

export interface EnabledFeature {
    label: Features;
    isEnabled: boolean;
}

export const SET_ENABLED_FEATURES = 'SET_ENABLED_FEATURES';

export type FeatureFlagActions = SetEnabledFeatures;
